<template>
  <div class="lg:px-12 md:px-12 px-2 lg:py-6 md:py-6 py-5 bg-fa">
    <div class="container mx-auto">
      <div class="mx-auto text-center">
        <!-- <h2 class="text4F0A4B fsize32 sm-fsize24 mb-2">
          Your Questions Answered:
          <span class="font-semibold">FAQs</span>
        </h2> -->
        <h2 class="text4F0A4B fsize30 sm-fsize24 mb-2">
          Have Questions? We are here to help.
        </h2>
        <!-- <p class="lg:mb-4 md:mb-4 mb-2 sm-fsize14">
          Have Questions? We are here to help.
        </p> -->
      </div>

      <!-- <b-input-group class="mt-12">
                 <b-input-group-append>
        <b-button
          variant="white"
          class="shadow-none border-search-icon flex items-center"
          aria-label="search"
        >
          <feather-icon
            class=" cursor-pointer rounded-l-lg"
            icon="SearchIcon"
            svgClasses="w-4 h-4"
          ></feather-icon>
        </b-button>
      </b-input-group-append>
      <b-form-input
        class="border"
        type="text"
        min="0.00"
        placeholder="Search"
      ></b-form-input>

     
    </b-input-group>
    </div> -->
      <div class="flex justify-center faqcol">
        <el-input
          class="lg:w-2/5 md:w-8/12 w-full bdr8px-ip ip-focus-none"
          placeholder="Search"
          v-model="searchQuery"
          @input="filterAndHighlight"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <span v-if="showNoMatchMessage" class="text-red-500 ml-4">
          No results found
        </span>
      </div>

      <el-collapse
        v-model="activeNames"
        @change="handleChange"
        class="mt-6 collapse-header-none collapse-wrap"
        accordion
      >
        <el-collapse-item
          v-for="(item, index) in FilteredMedicalFaq.data"
          :key="index"
          :name="index.toString()"
          :visible="item.answer.includes(searchQuery)"
        >
          <template #title>
            <div
              class="heading-style"
              v-html="highlightText(item.question)"
            ></div>
          </template>
          <div
            class="fsize14 px-2 heading-style"
            v-html="highlightText(item.answer)"
          ></div>
          <!-- <p class="fsize14 px-2">{{ item.answer }}</p> -->
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>
<script>
import "quill/dist/quill.snow.css";
import "quill/dist/quill.core.css";
import "quill/dist/quill.bubble.css";
import { mapState } from "vuex";
export default {
  data() {
    return {
      searchQuery: "",
      activeNames: ["0"],
      showNoMatchMessage: false,
      // allData: [],
      // allData: { data: [] },
    };
  },
  methods: {
    handleChange(activeNames) {
      // console.log(activeNames, "activeNames");
      this.activeNames = activeNames;
      // console.log("1234", this.FilteredMedicalFaq);
    },

    // async function() {
    //   this.allData.data = this.FilteredMedicalFaq || [];
    // },
    highlightText(text) {
      if (!this.searchQuery) return text;
      const keyword = this.searchQuery.replace(/[-[\]/{}()*+?.\\^$|]/g, "\\$&");
      const regex = new RegExp(`(${keyword})`, "gi");
      // return text.replace(regex, '<span class="highlight">$1</span>');

      const wrapper = document.createElement("div");
      wrapper.innerHTML = text;

      wrapper.querySelectorAll("*").forEach((node) => {
        node.childNodes.forEach((child) => {
          if (
            child.nodeType === Node.TEXT_NODE &&
            regex.test(child.textContent)
          ) {
            const highlightedHTML = child.textContent.replace(
              regex,
              '<span class="highlight">$1</span>'
            );
            child.replaceWith(
              ...new DOMParser().parseFromString(highlightedHTML, "text/html")
                .body.childNodes
            );
          }
        });
      });

      return wrapper.innerHTML;
    },
    filterAndHighlight() {
      const matchingIndexes = [];
      this.showNoMatchMessage = false;

      if (this.searchQuery.trim() === "") {
        this.activeNames = ["0"];
        return;
      }

      this.FilteredMedicalFaq.data.forEach((item, index) => {
        const questionMatch = item.question
          .toLowerCase()
          .includes(this.searchQuery.toLowerCase());
        const answerMatch = item.answer
          .toLowerCase()
          .includes(this.searchQuery.toLowerCase());
        if (questionMatch || answerMatch) {
          matchingIndexes.push(index.toString());
        }
      });

      this.activeNames = matchingIndexes;

      if (matchingIndexes.length === 0 && this.searchQuery.trim() !== "") {
        this.showNoMatchMessage = true;
      }
    },
  },
  computed: {
    ...mapState("medicalFaq", ["FilteredMedicalFaq"]),
    // filteredFaq() {
    //   if (!this.searchQuery) return this.FilteredMedicalFaq.data;
    //   const keyword = this.searchQuery.toLowerCase();
    //   return this.FilteredMedicalFaq.data.filter(
    //     (item) =>
    //       item.question.toLowerCase().includes(keyword) ||
    //       item.answer.toLowerCase().includes(keyword)
    //   );
    // },
  },
  async mounted() {
    // await this.function();
    // console.log("FilteredMedicalFaq", this.FilteredMedicalFaq);
  },
};
</script>
<style>
.bdr8px-ip > .el-input__inner {
  border-radius: 8px !important;
}
.el-input__inner:focus {
  border-color: #dcdfe6 !important;
  outline: 0;
}
.el-collapse-item__header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  height: 48px;
  line-height: 48px;
  background-color: #fff;
  color: #4f0a4b !important;
  cursor: pointer;
  border-bottom: none !important;
  font-size: 16px;
  font-weight: 500;
  -webkit-transition: border-bottom-color 0.3s;
  transition: border-bottom-color 0.3s;
  outline: 0;
}
.el-collapse {
  border-top: none !important;
  border-bottom: none !important;
}
.el-collapse-item__wrap {
  will-change: height;
  background-color: #fff;
  overflow: hidden;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-top: 1px solid #ebeef5 !important;
  border-bottom: none !important;
}
.el-collapse-item__content {
  padding-top: 20px !important;
}
.highlight {
  background-color: yellow;
}

.ql-size-huge {
  font-size: 2.5em;
}

.ql-size-large {
  font-size: 1.5em;
}

.ql-size-small {
  font-size: 0.75em;
}

.heading-style > h1 {
  font-size: 2.5em;
}

.heading-style > h2 {
  font-size: 1.8em;
}

.heading-style > h3 {
  font-size: 1.5em;
}

.heading-style > h4 {
  font-size: 1.15em;
}

.heading-style > h5 {
  font-size: 1em;
}

.heading-style > h6 {
  font-size: 0.8em;
}
</style>
